import retailSale from '@/api/retail-sale'
import student from '@/api/student-profile'
import product from '@/api/product'
import moment from 'moment'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  showData: [],
  branch_id: null,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().add(7, 'Day').format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM (state, date) {
    state.date_from = date
  },
  SET_DATE_TO (state, date) {
    state.date_to = date
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return retailSale.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  async find (context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await retailSale.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  store (context, data) {
    return retailSale.store(data)
  },
  update (context, { id, data }) {
    return retailSale.update(id, data)
  },
  destroy (context, id) {
    return retailSale.destroy(id)
  },
  searchingStudent (context, attrubutes) {
    return student.get({
      params: attrubutes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  searchProduct (context, attributes) {
    let params = Object.assign(
      {
        include: 'sale_code.u_o_m,sale_code.product_price',
        filter: {
          location_base: true,
          has_provided_sale_code: true,
          price_set: true
        },
        fields: {
          sale_code: 'pro_sale_code_id,product_id,uom_id,sale_code',
          'sale_code.u_o_m': 'uom_id,uom_cat_id,uom_name_en,is_default',
          'sale_code.product_price':
            'product_price_id,pro_sale_code_id,product_id,cost,sale_price'
        },
        page: -1
      },
      attributes
    )
    return product.get({
      params,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  pdf (context, id) {
    return retailSale.pdf(id)
  },
  bankStudent (context, studentId) {
    return retailSale.bankStudent(studentId)
  },
  bankProfile (context) {
    return retailSale.bankProfile()
  }
}
